<template>
  <single-panel-page>
    <RedirectAlert />
    <login-form :next="next">
      <span slot="footer" />
    </login-form>
  </single-panel-page>
</template>

<script>
import LoginForm from 'modules/auth/LoginForm.vue'
import RedirectAlert from './RedirectAlert'

export default {
  components: { LoginForm, RedirectAlert },
  props: {
    next: { type: String, default: null },
  },
  setup(props, { root }) {
    return {}
  },
}
</script>

<style scoped lang="scss">
.magic-link-help {
  cursor: pointer;
}
</style>
